// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__269mp","shimmer":"Skeleton_shimmer__23J3b","text":"Skeleton_text__2M6Ow","circle":"Skeleton_circle__126Tz","stack":"Skeleton_stack__RH_Qo"};